import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Porder } from 'src/app/assabil-sales/models/entities/porder';
import { ProcurementService } from 'src/app/assabil-sales/services/procurement.service';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { Warehouse } from 'src/app/assabil-kernel/models/entities/master-data/warehouse-entity';



@Component({
    selector: 'porder-list',
    templateUrl: './porder-list.component.html',
    styleUrls: ['./porder-list.component.scss']
})


export class PorderListComponent extends BasePage2<Porder> {

    porders         : Porder[] = [];
    code            : string;
    startDate       : Date;
    endDate         : Date;
    regular         : boolean = true;
    returns         : boolean = true;
    excludeClosed   : boolean = true;
    

    constructor(
        protected toastr            : ToastrService,
        protected procurementService: ProcurementService,
        protected router            : Router,
        protected baseService       : BaseService,
        protected leanUtilsService  : LeanUtilsService, 
        protected location          : Location,
        public    userService       : UserService) {
         super(toastr, router, baseService, leanUtilsService, location);

         this.entityName = 'porder';
    }

    ngAfterViewInit(){
        super.ngAfterViewInit();
        
        this.procurementService.pordersGet(null, null, null, this.regular, this.returns, true).then(result => {
            this.porders = result;
        })
    }

    getRows(): Porder[] {
        return this.porders;
    }

    saveRow(row: Porder): Promise<Porder> {
        return this. procurementService.porderSave(row);
    }

    loadData() {
        this. procurementService.pordersGet(this.code, this.startDate, this.endDate,  this.regular, this.returns, this.excludeClosed).then(result => {
            this.porders = result;
        }).catch(error => {
        })
    }

    newPorder(returnWt?: boolean) {
        let tmp             = new Porder();
        tmp.person          = new Person();
        tmp.role            = new Role();
        tmp.role.warehouse  = new Warehouse();
        tmp.returnPo        = returnWt;
        tmp.porderLines     = [];
        tmp.edit            = true; 
        tmp.inserted        = true; 
        this.selectedRow    = tmp;
    }


    selectRow(porder : Porder){
        this.selectedRowIndex = this.porders.indexOf(porder);

        this.procurementService.porderGet(porder.porderCode).then(result => {
          this.porders[this.selectedRowIndex] = result;
          this.selectedRow = result; 
        })
    }

}
